'use strict';
var cp = require('child_process');
// create processes
var path = require('path');
var workerModule1 = path.join(__dirname,'digitreader.js');
var worker = null;

var createWorker = function(workerName) {
  worker = cp.fork(workerName, { env : { ALGOINCHILDPROCESS : 1 } });
  worker.on('message', function(obj) {
    //console.log('workermessage')
    if(stack[obj.id]){
      stack[obj.id].callback(obj.err, obj.result);
      clearTimeout(stack[obj.id].timerId)
      delete stack[obj.id];
    } else {
      console.log("callback not found from stack");
    }
  })
  worker.on('exit', function(){
    console.log('worker '+ workerName + ' exit');
    createWorker(workerName)
  })
}

createWorker(workerModule1);
var stack = {};

module.exports.analyzeImage = function (pixels, config, callback, debugImage) {
  var now = new Date().getTime();
  stack[now] = {callback:callback};
  
  worker.send({config:config, id:now});
  stack[now].timerId = setTimeout(function() {
    if(stack[now]){
      stack[now].callback("timeout");
      delete stack[now];
    } else {
      console.log("callback not found from stack");
    }

  }, 8000) // 8 seconds is maximum time for algorihms
} 


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader/digitreader-master.js
// module id = 826
// module chunks = 0